import moment from "../../moment";

export const checkIsValidQrCode = (limited_at) => {
  // サーバー側とのタイムラグを考慮して、10秒前を期限とする
  var limit = moment(new Date(limited_at)).subtract(10, "s");
  var currentTime = moment(new Date());

  return currentTime.isBefore(limit);
};
